import type { SaveDraftItem } from '@shared/components/save-draft-modal/save-draft-modal.model';

export function resolveDraftIdsToDelete(
  drafts: SaveDraftItem[] = [],
  draftId: string | null,
): string[] {
  if (!draftId) {
    return [];
  }

  // Match on group membership, not on the group's id. A request spanning several
  // transactions is one group whose representative id is the lowest draft suffix, while
  // draftId tracks the active draft — usually a later sibling. Comparing against the id
  // alone missed the group and deleted only the active draft, orphaning the rest.
  const match = drafts.find((draft) => draft.allIds.includes(draftId));

  if (match) {
    return match.allIds;
  }

  return [draftId];
}
